import React from "react";
import { useTranslation } from "react-i18next";
import notFoundImg from "../../../assets/img/notFound.jpg";

export default function PersonalInfoThree({ profileInfo }) {
  const { perfil = {}, vendedor = {} } = profileInfo?.data || {};
  const { t } = useTranslation();
  const socialLinks = [
    {
      href: perfil.facebook,
      label: "Facebook",
      icon: "fa-brands fa-facebook-f",
    },
    {
      href: perfil.twitter,
      label: "Twitter",
      icon: "fa-brands fa-twitter",
    },
    {
      href: perfil.instagram,
      label: "Instagram",
      icon: "fa-brands fa-instagram",
    },
    {
      href: perfil.linkedin,
      label: "LinkedIn",
      icon: "fa-brands fa-linkedin-in",
    },
  ];

  return (
    <aside className="living-profile-column">
      <div className="bostami-parsonal-info-area">
        <div className="bostami-parsonal-info-wrap">
          <div className="bostami-parsonal-info-img">
            <img
              width={260}
              height={260}
              src={perfil.urlFoto || notFoundImg}
              alt={vendedor.nombre || t("app.asesor")}
            />
          </div>

          <h1 className="bostami-parsonal-info-name">{vendedor.nombre}</h1>
          <span className="bostami-parsonal-info-bio">
            {t("app.asesor")}
          </span>

          <ul className="bostami-parsonal-info-social-link">
            {socialLinks
              .filter(({ href }) => Boolean(href))
              .map(({ href, label, icon }) => (
                <li key={label}>
                  <a
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={label}
                  >
                    <i className={icon} aria-hidden="true"></i>
                  </a>
                </li>
              ))}
          </ul>

          <div className="living-contact-heading">
            <span>{t("app.contacto")}</span>
          </div>

          <div className="bostami-parsonal-info-contact">
            <div className="bostami-parsonal-info-contact-item">
              <div className="icon">
                <i className="fa-regular fa-phone" aria-hidden="true"></i>
              </div>
              <div className="text">
                <span>{t("app.telefono")}</span>
                <a href={`tel:${perfil.telefono}`}>{perfil.telefono}</a>
              </div>
            </div>

            <div className="bostami-parsonal-info-contact-item">
              <div className="icon">
                <i
                  className="fa-regular fa-envelope"
                  aria-hidden="true"
                ></i>
              </div>
              <div className="text">
                <span>{t("app.correo")}</span>
                <a href={`mailto:${perfil.email}`}>{perfil.email}</a>
              </div>
            </div>

            <div className="bostami-parsonal-info-contact-item">
              <div className="icon">
                <i
                  className="fa-solid fa-location-dot"
                  aria-hidden="true"
                ></i>
              </div>
              <div className="text">
                <span>{t("app.ubicacion")}</span>
                {perfil?.ubicacionMaps && (
                  <a
                    href={perfil.ubicacionMaps}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t("app.verUbicacion")}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
